import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const LegalLayout = ({ title, updated, children, testId }) => (
  <div data-testid={testId}>
    <section className="relative overflow-hidden bg-navy pb-16 pt-40">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-gold/10 blur-3xl" />
      <div className="relative mx-auto max-w-4xl px-6 lg:px-10">
        <span className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">Vobis Credit S.r.l.</span>
        <h1 className="mt-4 font-display text-4xl text-white sm:text-5xl lg:text-6xl">{title}</h1>
        <p className="mt-4 text-sm text-white/50">Ultimo aggiornamento: {updated}</p>
      </div>
    </section>
    <section className="bg-white py-20">
      <Reveal className="mx-auto max-w-4xl px-6 lg:px-10">
        <div className="space-y-10 text-sm leading-relaxed text-navy/70 md:text-base">{children}</div>
        <Link
          to="/"
          data-testid="legal-back-home"
          className="group mt-14 inline-flex items-center gap-2 text-sm font-semibold text-navy transition-colors hover:text-gold-dark"
        >
          <ArrowLeft size={16} className="transition-transform duration-300 group-hover:-translate-x-1" />
          Torna alla Home
        </Link>
      </Reveal>
    </section>
  </div>
);

const Section = ({ title, children }) => (
  <div>
    <h2 className="mb-3 font-display text-2xl text-navy">{title}</h2>
    {children}
  </div>
);

export const PrivacyPage = () => (
  <LegalLayout title="Privacy Policy" updated="1 gennaio 2026" testId="privacy-page">
    <Section title="1. Titolare del trattamento">
      <p>
        Il titolare del trattamento dei dati personali è Vobis Credit S.r.l. (P.IVA 18541881001,
        REA RM1791277), con sede legale in Viale dell'Arte 19/a – 00144 Roma, contattabile
        all'indirizzo email info@vobiscredit.it.
      </p>
    </Section>
    <Section title="2. Dati raccolti e finalità">
      <p>
        Attraverso il form di contatto raccogliamo nome, indirizzo email, numero di telefono,
        nome dell'azienda e il contenuto del messaggio. Tali dati sono trattati esclusivamente
        per rispondere alle richieste ricevute, valutare eventuali proposte commerciali e
        adempiere agli obblighi di legge.
      </p>
    </Section>
    <Section title="3. Base giuridica e conservazione">
      <p>
        Il trattamento si basa sul consenso dell'interessato e sull'esecuzione di misure
        precontrattuali. I dati sono conservati per il tempo necessario a gestire la richiesta
        e, in caso di rapporto commerciale, per la durata prevista dalla normativa applicabile.
      </p>
    </Section>
    <Section title="4. Diritti dell'interessato">
      <p>
        L'interessato può esercitare in qualsiasi momento i diritti previsti dagli artt. 15-22 del
        Regolamento (UE) 2016/679 (GDPR): accesso, rettifica, cancellazione, limitazione,
        portabilità e opposizione, scrivendo a info@vobiscredit.it. È inoltre possibile proporre
        reclamo all'autorità di controllo competente.
      </p>
    </Section>
  </LegalLayout>
);

export const CookiePage = () => (
  <LegalLayout title="Cookie Policy" updated="1 gennaio 2026" testId="cookie-page">
    <Section title="1. Cosa sono i cookie">
      <p>
        I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo
        dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla
        visita successiva.
      </p>
    </Section>
    <Section title="2. Cookie utilizzati da questo sito">
      <p>
        Questo sito utilizza esclusivamente cookie tecnici, necessari al corretto funzionamento
        delle pagine e della navigazione. Non vengono utilizzati cookie di profilazione,
        né cookie di terze parti a fini pubblicitari o di tracciamento.
      </p>
    </Section>
    <Section title="3. Gestione delle preferenze">
      <p>
        L'utente può gestire o eliminare i cookie direttamente dalle impostazioni del proprio
        browser. La disabilitazione dei cookie tecnici potrebbe compromettere il corretto
        funzionamento di alcune sezioni del sito.
      </p>
    </Section>
    <Section title="4. Aggiornamenti">
      <p>
        La presente Cookie Policy può essere aggiornata periodicamente. La data di ultimo
        aggiornamento è indicata in cima a questa pagina.
      </p>
    </Section>
  </LegalLayout>
);
